import { getDocChatTurnStatus } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatConversation'
import type { DocChatTurn } from 'features/knowledgeDocumentViewer/types'

export function completedSuccessfulTurns(turns: DocChatTurn[]): DocChatTurn[] {
  return turns.filter((turn) => getDocChatTurnStatus(turn) === 'complete')
}

export function getLastCompletedTurnId(
  turns: DocChatTurn[]
): string | undefined {
  return completedSuccessfulTurns(turns).at(-1)?.id
}

export function shouldUnarchiveOnFollowUp({
  archived,
  turns,
}: {
  archived: boolean
  turns: DocChatTurn[]
}): boolean {
  return (
    archived && turns.some((turn) => getDocChatTurnStatus(turn) === 'loading')
  )
}
